// LOAD ALL THE READ ONLY DATA
import { toast } from "react-toastify";
import { INCIDENCIA_STEPS_API } from "../views/MainLayout/components/shared/services/incidenciasSteps";
import { makeSetReducer } from "./utils";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

export const stepsFullfilledReducer = makeSetReducer(['steps/fullfilled']);

export const fetchSteps = () => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await INCIDENCIA_STEPS_API.get()
        const data = await response.data;
        dispatch({ type: 'steps/fullfilled', payload: data })
        const readOnly = JSON.parse(localStorage.getItem('read_only'));
        readOnly.steps = data;
        localStorage.setItem('read_only', JSON.stringify(readOnly));
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}